import { resolveAdminNamespace } from '@next-adapter/config/namespace/resolve-admin-namespace.js'

export function rewriteAdminModulePath(modulePath: string, namespace: string): string {
  const resolved = resolveAdminNamespace(namespace)

  if (modulePath === '@admin/auth/middleware') {
    return `${resolved.alias}/auth/session`
  }

  if (modulePath === '@admin/auth/auth' || modulePath === '@admin/auth') {
    return `${resolved.alias}/auth/server`
  }

  if (modulePath === '@admin/auth/client') {
    return `${resolved.alias}/auth/client`
  }

  if (modulePath === '@admin') {
    return resolved.alias
  }

  if (modulePath.startsWith('@admin/')) {
    return `${resolved.alias}${modulePath.slice('@admin'.length)}`
  }

  return modulePath
}
